if (!customElements.get('adev-site-header')) {
    customElements.define('adev-site-header', class adevSiteHeader extends HTMLElement {
        constructor() {
            super();
            
            this.lastScrollY = window.scrollY;
            this.isHeaderFixed = false;
            this.headerRect = this.getBoundingClientRect();
            this.headerTop = this.headerRect.top + window.scrollY;
        }

        setCssVars() {
            const headerHeight = this.offsetHeight;
            document.documentElement.style.setProperty('--adev-site-header-height', `${headerHeight}px`);
        }

        mobileMenuEvents() {
            const openMobileMenu = this.querySelector('[data-adev-site-header="open-menu"]');
            if (openMobileMenu) {
                openMobileMenu.addEventListener('click', function() {
                    const mobileMenu = document.querySelector('adev-mobile-menu');
                    if (mobileMenu) {
                        mobileMenu.open();
                    }
                });
            }
        }

        navMenuEvents() {
            this.querySelectorAll('[data-adev-site-header="nav-menu"]').forEach((menu) => {
                const navMenuA = menu.querySelectorAll('[data-adev-site-header="nav-menu-a"]');

                navMenuA.forEach((link) => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();

                        const li = link.parentElement;

                        if (li.classList.contains('is--active')) {
                            li.classList.remove('is--active');
                            return;
                        }

                        this.querySelectorAll('[data-adev-site-header="nav-menu"] li.is--active').forEach((activeLi) => {
                            activeLi.classList.remove('is--active');
                        });

                        li.classList.add('is--active');
                    });
                });

                const navSubmenuOpen = menu.querySelectorAll('[data-adev-site-header="nav-submenu-a"]');

                navSubmenuOpen.forEach((link) => {
                    link.addEventListener('click', function(e) {
                        e.preventDefault();

                        const li = link.parentElement;

                        if (li.classList.contains('is--active')) {
                            li.classList.remove('is--active');
                            return;
                        }

                        li.classList.add('is--active');
                    });
                });

            });
        }

        cartDrawerEvents() {
            const openCartDrawer = this.querySelector('[data-adev-site-header="open-cart"]');
            if (openCartDrawer) {
                openCartDrawer.addEventListener('click', function(e) {
                    e.preventDefault();

                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                        cartDrawer.open();
                    }
                });
            }
        }

        handleHeaderFixed() {
            const headerTop = this.headerTop;
            const headerHeight = this.offsetHeight;
            const currentScrollY = window.scrollY;

            if (currentScrollY > headerTop + headerHeight) {
                if (currentScrollY < this.lastScrollY) {
                    if (!this.isHeaderFixed) {
                        this.classList.add('is--fixed');
                        this.isHeaderFixed = true;
                    }
                } else if (currentScrollY > this.lastScrollY) {
                    if (this.isHeaderFixed) {
                        this.classList.remove('is--fixed');
                        this.isHeaderFixed = false;
                    }
                }
            } else {
                if (this.isHeaderFixed) {
                    this.classList.remove('is--fixed');
                    this.isHeaderFixed = false;
                }
            }

            this.lastScrollY = currentScrollY;
        }
        
        onScroll() {
            this.handleHeaderFixed();
        }

        onResize() {
            this.setCssVars();
        }

        outsideClickListener(e) {
            if (!e.target.closest('[data-adev-site-header="nav-menu"]')) {
                document.querySelectorAll('[data-adev-site-header="nav-menu"] li.is--active').forEach((li) => {
                    li.classList.remove('is--active');
                });
            }
        }

        connectedCallback() {
            this.setCssVars();
            this.handleHeaderFixed();

            window.addEventListener('scroll', this.onScroll.bind(this));
            window.addEventListener('resize', this.onResize.bind(this));

            this.mobileMenuEvents();
            this.navMenuEvents();
            this.cartDrawerEvents();

            document.addEventListener('click', this.outsideClickListener.bind(this));
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScroll.bind(this));
            window.removeEventListener('resize', this.onResize.bind(this));
            document.removeEventListener('click', this.outsideClickListener.bind(this));
        }

    });
}